import React from 'react';
import { Box, Typography, Card, CardContent, SvgIcon } from "@mui/material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactComponent as CasesSvg } from '../assets/icons/clinical_notes.svg';

const CasesIcon = React.forwardRef((props, ref) => (
    <SvgIcon component={CasesSvg} viewBox="0 0 24 24" ref={ref} {...props} />
));

export default function PortalHeader({ userFirstName, userEmail, userPhone, user }) {
    const navigate = useNavigate();
    const location = useLocation();
    
    const isCaseList = location.pathname.startsWith('/case-list');
    const isAppointmentList = location.pathname.startsWith('/appointment-list');

    return (
        <>
            {/* Welcome Card */}
            <Card
                elevation={0}
                sx={{
                    mb: 2,
                    background: 'linear-gradient(135deg, #ffffff 0%, #fafafa 50%, #f5f5f5 100%)',
                    border: '1px solid',
                    borderColor: '#e0e0e0',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                    width: '100%',
                }}
            >
                <CardContent sx={{ pt: 2, px: 2, pb: 1.5, '&:last-child': { pb: 1.5 } }}>
                    <Typography variant="body1" sx={{ color: '#1a1a2e', fontWeight: 600, mb: 0.5 }}>
                        Welcome back{userFirstName ? `, ${userFirstName}` : ''}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#5a5a6e' }}>
                        Email: {userEmail || user?.email || 'N/A'}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#5a5a6e' }}>
                        Phone: {userPhone || 'N/A'}
                    </Typography>
                </CardContent>
            </Card>

            {/* Tab Switcher */}
            <Box
                sx={{
                    display: 'flex',
                    backgroundColor: '#f1f5f9',
                    borderRadius: '12px',
                    p: 0.5,
                    mb: 2,
                    width: '100%',
                    gap: 0,
                }}
            >
                <Box
                    onClick={() => navigate('/case-list', { state: { viaBottomNav: true } })}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 0.75,
                        flex: 1,
                        px: 2,
                        py: 1,
                        borderRadius: '12px',
                        backgroundColor: isCaseList ? 'white' : 'transparent',
                        boxShadow: isCaseList ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s',
                        '&:hover': {
                            backgroundColor: isCaseList ? 'white' : 'rgba(255, 255, 255, 0.5)',
                        },
                    }}
                >
                    <CasesIcon sx={{ fontSize: 20, color: isCaseList ? '#1a1a1a' : '#6b7280' }} />
                    <Typography sx={{ 
                        fontWeight: isCaseList ? 600 : 500, 
                        fontSize: '0.84rem', 
                        color: isCaseList ? '#1a1a1a' : '#6b7280' 
                    }}>
                        Visits
                    </Typography>
                </Box>
                <Box
                    onClick={() => navigate('/appointment-list', { state: { viaBottomNav: true } })}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 0.75,
                        flex: 1,
                        px: 2,
                        py: 1,
                        borderRadius: '12px',
                        backgroundColor: isAppointmentList ? 'white' : 'transparent',
                        boxShadow: isAppointmentList ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s',
                        '&:hover': {
                            backgroundColor: isAppointmentList ? 'white' : 'rgba(255, 255, 255, 0.5)',
                        },
                    }}
                >
                    <CalendarMonthIcon sx={{ fontSize: 20, color: isAppointmentList ? '#1a1a1a' : '#6b7280' }} />
                    <Typography sx={{ 
                        fontWeight: isAppointmentList ? 600 : 500, 
                        fontSize: '0.84rem', 
                        color: isAppointmentList ? '#1a1a1a' : '#6b7280' 
                    }}>
                        Appointments
                    </Typography>
                </Box>
            </Box>
        </>
    );
}
